/**
 * Personal drag-to-reorder — shared by branch-option reordering
 * (FlowPlayerPage's NodePersonalization.edge_order) and whole-script step
 * reordering (StepOrderDialog's FlowStepOrder.node_order). Same algorithm,
 * different id fields: a Staff member's own saved order laid on top of
 * whatever the admin-authored default order is.
 */

/** Applies a saved personal order (`order`, a list of ids, most-preferred
 * first) on top of `items`, which is already sorted by the admin-authored
 * default. Items named in `order` come first, in that order; anything not
 * named (added after this Staff member last reordered, or no
 * personalization at all) keeps its original relative position after
 * them. A no-op (returns `items` unchanged) when there's nothing to
 * apply. */
export function applyPersonalOrder<T extends { id: string }>(
  items: T[],
  order: string[] | undefined
): T[] {
  if (!order || order.length === 0) return items;
  const rank = new Map(order.map((id, i) => [id, i]));
  return [...items].sort((a, b) => {
    const ra = rank.has(a.id) ? rank.get(a.id)! : Number.MAX_SAFE_INTEGER;
    const rb = rank.has(b.id) ? rank.get(b.id)! : Number.MAX_SAFE_INTEGER;
    return ra - rb; // Array.prototype.sort is stable — ties keep incoming order.
  });
}
